import { render, staticRenderFns } from "./AscDocMgmtHelpAboutGridWrapper.vue?vue&type=template&id=ca638fd6&"
import script from "./AscDocMgmtHelpAboutGridWrapper.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtHelpAboutGridWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscDocMgmtHelpAboutGridWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports